import * as React from "react";
import BOListTemplates from "./DocumentTemplates/bolisttemplates";
import DocuTemplates from "./DocumentTemplates/docutemplates";
import arrow_gray from "../images/arrow_gray_product.gif";
import ButtonNavigation from "./BottomNavigation/bottomNavigation";

interface Props {
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  selectedPage: string;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  country: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  selectedOption: string;
}

const GermanOptions: React.FC<Props> = (props) => {
  const {
    setSelectedPage,
    selectedPage,
    setSelectedCountry,
    country,
    setSelectedOption,
    selectedOption,
  } = props;

  const handleChange = (event:React.ChangeEvent<HTMLInputElement>)=> {
    setSelectedOption(event.target.value);    
  }
  
  return (
    <div>
      <p>Upload Beneficial Owner List - Step 2 of 5</p>
      <p>Germany</p>
      <div className="inline">
        <BOListTemplates country="Germany" />
        <DocuTemplates country="Germany" />
      </div>

      <div className="inline" style={{ width: "70%" }}>
        <p className="subTitle"> Type selection </p>
        <p>
          Please select the security type matching your B.O. list, then click
          'Continue'.
        </p>

        <div
          style={{
            padding: "40px",
            backgroundColor: "#f1f0f0",
          }}
        >
          <div
            style={{
              position: "relative",
            }}
          >
            <img
              src={arrow_gray}
              alt=""
              width="15"
              height="9"
              style={{
                margin: "0 0 0 0",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <label
              style={{
                margin: "0 0 0 20px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              Germant Tax Voucher
            </label>

            <input
              type="radio"
              id="GermanTaxVoucher"
              name="GermanOption"
              value="German Tax Voucher"
              style={{
                margin: "0 0 0 320px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              checked={selectedOption === "German Tax Voucher"}
              onChange={handleChange}
            />
          </div>
          <br /><br />
          <div
            style={{              
              position: "relative",
            }}
          >
            <img
              src={arrow_gray}
              alt=""
              width="15"
              height="9"
              style={{
                margin: "0 0 0 0",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            ></img>
            <label
              style={{
                margin: "0 0 0 20px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              German Tax Breakdown
            </label>
            <input
              type="radio"
              id="GermanTaxBreakdown"
              name="GermanOption"
              value="German Tax Breakdown"
              style={{
                margin: "0 0 0 320px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              checked={selectedOption === "German Tax Breakdown"}
              onChange={handleChange}
            />
          </div>
          <br /><br />
          <div
            style={{              
              position: "relative",
            }}
          >
            <img
              src={arrow_gray}
              alt=""
              width="15"
              height="9"
              style={{
                margin: "0 0 0 0",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            ></img>
            <label
              style={{
                margin: "0 0 0 20px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              German Reporting Standing Instruction InvStG
            </label>
            <input
              type="radio"
              id="GermanReporting"
              name="GermanOption"
              value="German Reporting Standing Instruction InvStG"
              style={{
                margin: "0 0 0 320px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              checked={selectedOption === "German Reporting Standing Instruction InvStG"}
              onChange={handleChange}
            />
          </div>
        </div>

        <ButtonNavigation
          setSelectedPage={setSelectedPage}
          selectedPage={selectedPage}
          setSelectedCountry={setSelectedCountry}
          country={country}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
        />
      </div>
    </div>
  );
};

export default GermanOptions;
